import Vue from 'vue'
import Vuex from 'vuex'

import { state } from "./main/state";
import { actions } from "./main/actions";
import { mutations } from "./main/mutations";
import { getters } from './main/getters';
import { tags } from "./tags/index";
import { events } from "./events/index";
import { services } from "./services/index";
import { program } from './program/index';
import { chat } from '../../share/chat/store/index.js';
import { invites } from '../../share/invites/store/index';
import { formModal } from "./form-modal";
import { onlineUsers } from "./online-users";
import { profiles } from '../../share/profile/store';
import { routing } from "./routing";
import { points } from "./points";
import { expertRatings } from "./expert-ratings";
import { miniPlayer } from "./mini-player";
import { backgroundView } from "./background-view"
import { webConference } from '@share/web-conferences/store';
import { notice } from './notice';
import { favorites } from './favorites';
import { stage } from "./stage"
import { settings } from "@service/store/settings";

Vue.use(Vuex);

export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: {
    events, program, chat, invites, formModal, profiles, services, onlineUsers,
    routing, points, expertRatings, webConference, miniPlayer, backgroundView, stage, tags, notice,
    favorites, settings
  }
})
